import { AssigneeSelect, type AssigneeSelectProps } from '@indipia/shared-features';

/**
 * 담당자·관리자 조회 조건 — 왼쪽에 '담당자·관리자' 라벨, 오른쪽에 공용 AssigneeSelect 를 같은 줄에 둔다.
 * (2026-10-12 개선사항 D-4·D-5·D-7 — 기획 html 의 .rf / .v15-label 묶음)
 * placeholder 는 넘기지 않는다 — 공용 기본값('직원을 선택하세요')을 쓴다.
 *
 * @param bordered 묶음 전체에 테두리를 두른다(B 현장 목록: 상태 칩 오른쪽 그룹)
 */
export function AssigneeFilterField({
  bordered = false,
  ...selectProps
}: Omit<AssigneeSelectProps, 'placeholder' | 'label' | 'className'> & { bordered?: boolean }) {
  return (
    <div
      className={`flex shrink-0 items-center gap-03 ${bordered ? 'rounded-md border border-border py-01 pl-03 pr-01' : ''}`}
    >
      <span className="whitespace-nowrap text-caption font-bold text-text-secondary">담당자·관리자</span>
      {/* 폭 192 = spacing-13(160) + spacing-07(32) — 기획 html 의 선택 상자 폭(190)에 맞춘 토큰 합 */}
      <AssigneeSelect className="w-[calc(var(--spacing-13)+var(--spacing-07))] shrink-0" {...selectProps} />
    </div>
  );
}
